import { styled } from "@mui/material";
import { LetterSpacing } from "../../../foundations/typography.es.js";
import { Typography } from "../../typography/typography.es.js";
const TooltipDescriptionTypographyContainer = styled(Typography)({
  letterSpacing: LetterSpacing.wider
});
export {
  TooltipDescriptionTypographyContainer
};
//# sourceMappingURL=description-typography-container.es.js.map
